var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function initSortDropdown() {
  var _a;
  const sortBtn = document.getElementById("collectionSortBtn");
  const sortDropdown = (_a = sortBtn == null ? void 0 : sortBtn.closest(".sort-dropdown")) == null ? void 0 : _a.querySelector(".sort-dropdown-content");
  const caretWrapper = sortBtn == null ? void 0 : sortBtn.querySelector(".collection-sort-caret-wrapper");
  if (!sortBtn || !sortDropdown || !caretWrapper) {
    return false;
  }
  sortBtn.addEventListener("click", (e) => {
    e.preventDefault();
    const isExpanded = sortBtn.getAttribute("aria-expanded") === "true";
    toggleDropdown(!isExpanded);
  });
  let sortDropdownHandler = null;
  function registerSortDropdown() {
    if (window.GlobalClickHandlers && !sortDropdownHandler) {
      sortDropdownHandler = {
        shouldClose: (e) => !sortBtn.contains(e.target),
        close: () => toggleDropdown(false)
      };
      window.GlobalClickHandlers.registerDropdown(sortDropdownHandler);
    }
  }
  function unregisterSortDropdown() {
    if (window.GlobalClickHandlers && sortDropdownHandler) {
      window.GlobalClickHandlers.unregisterDropdown(sortDropdownHandler);
      sortDropdownHandler = null;
    }
  }
  sortBtn.addEventListener("click", () => {
    registerSortDropdown();
  });
  if (window.GlobalClickHandlers) {
    registerSortDropdown();
  }
  window.addEventListener("beforeunload", unregisterSortDropdown);
  sortBtn.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      const isExpanded = sortBtn.getAttribute("aria-expanded") === "true";
      toggleDropdown(!isExpanded);
    }
  });
  const useAjaxFiltering = window.useAjaxFiltering === true;
  if (!useAjaxFiltering) {
    const sortOptions = sortDropdown.querySelectorAll("a");
    sortOptions.forEach((option) => {
      option.addEventListener("click", (e) => {
        e.preventDefault();
        const sortValue = option.dataset.value;
        applySorting(sortValue);
      });
    });
  }
  function toggleDropdown(show) {
    sortBtn.setAttribute("aria-expanded", show);
    sortDropdown.classList.toggle("hidden", !show);
    caretWrapper.classList.toggle("flipped", show);
  }
  function applySorting(sortValue) {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    searchParams.set("sort_by", sortValue);
    if (searchParams.has("page")) {
      searchParams.delete("page");
    }
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.location.href = newUrl;
  }
  sortBtn.setAttribute("aria-haspopup", "true");
  sortBtn.setAttribute("aria-expanded", "false");
  return true;
}
let isFilterOptionsInitialized = false;
let filterOptionsInitAttempts = 0;
const MAX_FILTER_OPTIONS_ATTEMPTS = 3;
function initializeFilterOptionsWithRetry() {
  if (isFilterOptionsInitialized) {
    return Promise.resolve(true);
  }
  const success = initFilterOptionsStyling();
  if (!success && filterOptionsInitAttempts < MAX_FILTER_OPTIONS_ATTEMPTS) {
    filterOptionsInitAttempts++;
    return new Promise((resolve) => {
      setTimeout(() => {
        initializeFilterOptionsWithRetry().then(resolve);
      }, 500);
    });
  } else if (success) {
    isFilterOptionsInitialized = true;
    filterOptionsInitAttempts = 0;
  }
  return Promise.resolve(success);
}
function initFilterOptionsStyling() {
  const checkboxes = document.querySelectorAll(".hidden-checkbox");
  if (checkboxes.length === 0) {
    return false;
  }
  checkboxes.forEach((checkbox) => {
    const label = checkbox.closest(".filter-option-label");
    if (checkbox.checked) {
      label.classList.add("filter-option-active");
    } else {
      label.classList.remove("filter-option-active");
    }
  });
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function() {
      const label = this.closest(".filter-option-label");
      if (this.checked) {
        label.classList.add("filter-option-active");
      } else {
        label.classList.remove("filter-option-active");
      }
    });
  });
  return true;
}
function setupFilterOptionsInitializers() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeFilterOptionsWithRetry();
    });
  } else {
    initializeFilterOptionsWithRetry();
  }
  window.addEventListener("load", () => {
    if (!isFilterOptionsInitialized) {
      initializeFilterOptionsWithRetry();
    }
  });
  document.addEventListener("criticalReady", () => {
    if (!isFilterOptionsInitialized) {
      initializeFilterOptionsWithRetry();
    }
  });
}
setupFilterOptionsInitializers();
if (window.Shopify && window.Shopify.designMode !== true) {
  setTimeout(() => {
    const filterOptions = document.querySelector(".hidden-checkbox");
    if (filterOptions && !isFilterOptionsInitialized) {
      initializeFilterOptionsWithRetry();
    }
  }, 1e3);
}
function initFilterFormHandlers(drawer = null) {
  if (window.useAjaxFiltering) {
    return false;
  }
  const filterForm = document.getElementById("FilterDrawerForm");
  if (!filterForm) {
    return false;
  }
  filterForm.addEventListener("submit", (e) => {
    e.preventDefault();
    applyFilters(filterForm, drawer);
  });
  const resetButton = filterForm.querySelector(".filter-clear-button");
  if (resetButton) {
    resetButton.addEventListener("click", (e) => {
      e.preventDefault();
      resetFilters(filterForm, drawer);
    });
  }
  return true;
}
function applyFilters(form, drawer = null) {
  if (window.showFilterLoading) {
    window.showFilterLoading();
  }
  const formData = new FormData(form);
  const searchParams = new URLSearchParams();
  const currentUrl = new URL(window.location.href);
  for (const [key, value] of formData.entries()) {
    if (value) {
      searchParams.append(key, value);
    }
  }
  if (currentUrl.searchParams.has("sort_by")) {
    searchParams.set("sort_by", currentUrl.searchParams.get("sort_by"));
  }
  if (currentUrl.searchParams.has("q")) {
    searchParams.set("q", currentUrl.searchParams.get("q"));
  }
  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  window.location.href = newUrl;
}
function resetFilters(form, drawer = null) {
  if (window.showFilterLoading) {
    window.showFilterLoading();
  }
  const searchParams = new URLSearchParams();
  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.has("sort_by")) {
    searchParams.set("sort_by", currentUrl.searchParams.get("sort_by"));
  }
  if (currentUrl.searchParams.has("q")) {
    searchParams.set("q", currentUrl.searchParams.get("q"));
  }
  const newUrl = searchParams.toString() ? `${window.location.pathname}?${searchParams.toString()}` : window.location.pathname;
  window.location.href = newUrl;
}
function initFilterVisibility() {
  const filterGroups = document.querySelectorAll(".filter-group");
  if (!filterGroups.length) {
    return false;
  }
  filterGroups.forEach((group) => {
    var _a, _b, _c, _d;
    const emptyMessage = document.createElement("div");
    emptyMessage.className = "filter-group-empty-message";
    const translations = ((_c = (_b = (_a = window.theme) == null ? void 0 : _a.translations) == null ? void 0 : _b.collections) == null ? void 0 : _c.filters) || {};
    emptyMessage.textContent = translations.empty_filter_group || "No options available with current selection";
    (_d = group.querySelector(".filter-options")) == null ? void 0 : _d.appendChild(emptyMessage);
    if (group.classList.contains("filter-group--price")) {
      group.classList.remove("empty-group");
      group.classList.remove("empty");
    } else {
      const filterOptions = group.querySelectorAll(".filter-option");
      filterOptions.forEach((option) => {
        const countElement = option.querySelector(".filter-count");
        if (countElement) {
          const countText = countElement.textContent || "";
          const count = parseInt(countText.replace(/[^0-9]/g, ""), 10) || 0;
          option.setAttribute("data-count", count);
          const label = option.querySelector(".filter-option-label");
          const checkbox = option.querySelector('input[type="checkbox"]');
          if (count === 0 && !checkbox.checked) {
            label.classList.add("disabled");
          } else {
            label.classList.remove("disabled");
          }
        }
      });
      updateGroupVisibility(group);
    }
  });
  setupVisibilityChangeHandlers();
  return true;
}
function setupVisibilityChangeHandlers() {
  const checkboxes = document.querySelectorAll('.filter-option input[type="checkbox"]');
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const filterGroups = document.querySelectorAll(".filter-group:not(.filter-group--price)");
      filterGroups.forEach(updateGroupVisibility);
    });
  });
}
function updateGroupVisibility(group) {
  if (group.classList.contains("filter-group--price")) {
    group.classList.remove("empty-group");
    group.classList.remove("empty");
    return;
  }
  const options = group.querySelectorAll(".filter-option");
  const hasVisibleOptions = Array.from(options).some((option) => {
    const count = parseInt(option.getAttribute("data-count"), 10) || 0;
    const isActive = option.querySelector('input[type="checkbox"]').checked;
    return count > 0 || isActive;
  });
  if (!hasVisibleOptions) {
    group.classList.add("empty-group");
    group.classList.add("empty");
  } else {
    group.classList.remove("empty-group");
    group.classList.remove("empty");
  }
}
function updateFilterCounts(filterData) {
  if (!filterData || !filterData.filters) {
    return false;
  }
  filterData.filters.forEach((filter) => {
    const groupElement = document.querySelector(`.filter-group[data-filter-group="${filter.label.toLowerCase().replace(/\s+/g, "-")}"]`);
    if (!groupElement) return;
    if (groupElement.classList.contains("filter-group--price")) {
      return;
    }
    filter.values.forEach((value) => {
      var _a;
      const optionElement = (_a = groupElement.querySelector(`.filter-option input[name="${value.param_name}"][value="${value.value}"]`)) == null ? void 0 : _a.closest(".filter-option");
      if (!optionElement) return;
      const countElement = optionElement.querySelector(".filter-count");
      if (countElement) {
        countElement.textContent = `(${value.count})`;
      }
      optionElement.setAttribute("data-count", value.count);
      const label = optionElement.querySelector(".filter-option-label");
      const checkbox = optionElement.querySelector('input[type="checkbox"]');
      if (value.count === 0 && !checkbox.checked) {
        label.classList.add("disabled");
      } else {
        label.classList.remove("disabled");
      }
    });
    updateGroupVisibility(groupElement);
  });
  return true;
}
let isFilterGroupsInitialized = false;
let filterInitAttempts = 0;
const MAX_FILTER_ATTEMPTS = 3;
if (!window.userExpandedGroups) {
  window.userExpandedGroups = /* @__PURE__ */ new Set();
}
const userExpandedGroups = window.userExpandedGroups;
function captureFilterGroupsState() {
  const filterDrawer = document.querySelector(".collection-filter-drawer-content");
  if (!filterDrawer) return [];
  const filterGroups = filterDrawer.querySelectorAll(".filter-group-details");
  const openGroups = [];
  filterGroups.forEach((group, index) => {
    if (group.hasAttribute("open")) {
      openGroups.push(index);
    }
  });
  return openGroups;
}
function restoreFilterGroupsState(openGroups) {
  if (!openGroups || !Array.isArray(openGroups)) return;
  const filterDrawer = document.querySelector(".collection-filter-drawer-content");
  if (!filterDrawer) return;
  const filterGroups = filterDrawer.querySelectorAll(".filter-group-details");
  filterGroups.forEach((group, index) => {
    if (openGroups.includes(index)) {
      group.setAttribute("open", "");
    }
  });
}
function animateContent(content, isOpen) {
  const running = content.getAnimations();
  running.forEach((animation) => animation.cancel());
  content.style.height = "auto";
  content.style.display = "block";
  const computedStyle = window.getComputedStyle(content);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);
  const marginTop = parseFloat(computedStyle.marginTop);
  const marginBottom = parseFloat(computedStyle.marginBottom);
  const contentHeight = content.scrollHeight;
  const totalHeight = contentHeight + paddingTop + paddingBottom + marginTop + marginBottom;
  content.style.height = isOpen ? "0px" : `${totalHeight}px`;
  const heightAnimation = content.animate([
    { height: isOpen ? "0px" : `${totalHeight}px` },
    { height: isOpen ? `${totalHeight}px` : "0px" }
  ], {
    duration: 200,
    easing: "ease-in-out",
    fill: "forwards"
  });
  const opacityAnimation = content.animate([
    { opacity: isOpen ? 0 : 1 },
    { opacity: isOpen ? 0 : 0.7, offset: 0.5 },
    // Mid-point for smoother fade
    { opacity: isOpen ? 1 : 0 }
  ], {
    duration: 300,
    // Longer duration for fade
    easing: "ease-in-out",
    fill: "forwards"
  });
  Promise.all([heightAnimation.finished, opacityAnimation.finished]).then(() => {
    content.style.height = isOpen ? "auto" : "0px";
    content.style.opacity = isOpen ? "1" : "0";
  });
  return { heightAnimation, opacityAnimation };
}
function setupFilterGroupListeners() {
  const filterDrawer = document.querySelector(".collection-filter-drawer-content");
  if (!filterDrawer) return;
  const filterGroups = filterDrawer.querySelectorAll(".filter-group-details");
  filterGroups.forEach((group, index) => {
    const summary = group.querySelector("summary");
    if (!summary) return;
    summary.removeEventListener("click", summary.clickHandler);
    summary.clickHandler = (e) => __async(this, null, function* () {
      e.preventDefault();
      const isCurrentlyOpen = group.hasAttribute("open");
      const content = group.querySelector(".filter-options");
      if (!content) return;
      if (!isCurrentlyOpen) {
        group.setAttribute("open", "");
        userExpandedGroups.add(index);
        animateContent(content, true);
      } else {
        userExpandedGroups.delete(index);
        const { heightAnimation, opacityAnimation } = animateContent(content, false);
        yield Promise.all([heightAnimation.finished, opacityAnimation.finished]);
        group.removeAttribute("open");
      }
    });
    summary.addEventListener("click", summary.clickHandler);
    if (userExpandedGroups.has(index)) {
      group.setAttribute("open", "");
      const content = group.querySelector(".filter-options");
      if (content) {
        content.style.height = "auto";
        content.style.opacity = "1";
      }
    } else {
      const content = group.querySelector(".filter-options");
      if (content) {
        content.style.height = "0px";
        content.style.opacity = "0";
      }
    }
  });
}
function applyDefaultState() {
  const container = document.querySelector("[data-filter-groups-state]");
  if (!container) return false;
  const filterDrawer = document.querySelector(".collection-filter-drawer-content");
  if (!filterDrawer) return false;
  const filterGroupsState = container.dataset.filterGroupsState;
  const filterGroups = filterDrawer.querySelectorAll(".filter-group-details");
  filterGroups.forEach((group) => {
    group.removeAttribute("open");
    const content = group.querySelector(".filter-options");
    if (content) {
      content.style.height = "0px";
      content.style.opacity = "0";
    }
  });
  switch (filterGroupsState) {
    case "first_open":
      if (filterGroups[0]) {
        const content = filterGroups[0].querySelector(".filter-options");
        if (content) {
          content.style.height = "auto";
          content.style.opacity = "1";
        }
        filterGroups[0].setAttribute("open", "");
      }
      break;
    case "all_open":
      filterGroups.forEach((group) => {
        const content = group.querySelector(".filter-options");
        if (content) {
          content.style.height = "auto";
          content.style.opacity = "1";
        }
        group.setAttribute("open", "");
      });
      break;
  }
  return true;
}
function initFilterGroupsWithRetry(preserveState = false) {
  if (isFilterGroupsInitialized) {
    return;
  }
  const success = initFilterGroupsState(preserveState);
  if (!success) {
    if (filterInitAttempts < MAX_FILTER_ATTEMPTS) {
      filterInitAttempts++;
      setTimeout(() => initFilterGroupsWithRetry(preserveState), 500);
    }
  } else {
    isFilterGroupsInitialized = true;
    filterInitAttempts = 0;
  }
}
function initFilterGroupsState(preserveState = false) {
  const filterDrawer = document.querySelector(".collection-filter-drawer-content");
  if (!filterDrawer) return false;
  setupFilterGroupListeners();
  if (userExpandedGroups.size > 0) {
    const filterGroups = filterDrawer.querySelectorAll(".filter-group-details");
    filterGroups.forEach((group, index) => {
      const content = group.querySelector(".filter-options");
      if (userExpandedGroups.has(index)) {
        if (content) {
          content.style.height = "auto";
          content.style.opacity = "1";
        }
        group.setAttribute("open", "");
      } else {
        if (content) {
          content.style.height = "0px";
          content.style.opacity = "0";
        }
        group.removeAttribute("open");
      }
    });
    return true;
  }
  if (preserveState) {
    const currentState = captureFilterGroupsState();
    if (currentState && currentState.length > 0) {
      restoreFilterGroupsState(currentState);
      return true;
    }
  }
  return applyDefaultState();
}
function setupFilterInitializers() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initFilterGroupsWithRetry();
    });
  } else {
    initFilterGroupsWithRetry();
  }
  window.addEventListener("load", () => {
    if (!isFilterGroupsInitialized) {
      initFilterGroupsWithRetry();
    }
  });
  document.addEventListener("criticalReady", () => {
    if (!isFilterGroupsInitialized) {
      initFilterGroupsWithRetry();
    }
  });
}
setupFilterInitializers();
if (window.Shopify && window.Shopify.designMode !== true) {
  setTimeout(() => {
    const filterDrawer = document.querySelector(".collection-filter-drawer-content");
    if (filterDrawer && !isFilterGroupsInitialized) {
      initFilterGroupsWithRetry();
    }
  }, 1e3);
}
function initFilterActionsVisibility() {
  const filterActions = document.querySelector(".filter-actions");
  if (!filterActions) {
    return false;
  }
  filterActions.classList.add("filter-actions-animated");
  filterActions.classList.add("is-hidden");
  initApplyButtonVisibility();
  setTimeout(() => {
    updateFilterActionsVisibility();
  }, 100);
  setupFilterChangeListeners();
  return true;
}
function initApplyButtonVisibility() {
  const applyButtonWrapper = document.querySelector(".filter-apply-button-wrapper");
  if (!applyButtonWrapper) {
    return;
  }
  const collectionMain = document.querySelector(".collection-main");
  const showApplyButton = (collectionMain == null ? void 0 : collectionMain.getAttribute("data-show-filter-apply-button")) === "true";
  if (!showApplyButton) {
    applyButtonWrapper.style.display = "none";
  } else {
    applyButtonWrapper.style.display = "block";
  }
}
function setupFilterChangeListeners() {
  const filterForm = document.getElementById("FilterDrawerForm");
  if (filterForm) {
    filterForm.addEventListener("change", (e) => {
      updateFilterActionsVisibility();
    });
  }
  const resetButton = document.querySelector('.filter-actions button[type="reset"]');
  if (resetButton) {
    resetButton.addEventListener("click", () => {
      setTimeout(() => {
        updateFilterActionsVisibility();
      }, 50);
    });
  }
  document.addEventListener("theme:collection:updated", () => {
    updateFilterActionsVisibility();
  });
  document.addEventListener("collection:updated", () => {
    updateFilterActionsVisibility();
  });
}
function hasActiveFilters() {
  const activeCheckboxes = document.querySelectorAll('.filter-option input[type="checkbox"]:checked');
  if (activeCheckboxes.length > 0) {
    return true;
  }
  try {
    const url = new URL(window.location.href);
    for (const [key, value] of url.searchParams.entries()) {
      if (key !== "sort_by" && key !== "page" && key !== "q") {
        return true;
      }
    }
  } catch (e) {
  }
  return false;
}
function updateFilterActionsVisibility() {
  const filterActions = document.querySelector(".filter-actions");
  if (!filterActions) {
    return;
  }
  const hasFilters = hasActiveFilters();
  if (hasFilters) {
    filterActions.classList.add("is-visible");
    filterActions.classList.remove("is-hidden");
  } else {
    filterActions.classList.add("is-hidden");
    filterActions.classList.remove("is-visible");
  }
}
let isPriceSliderInitialized = false;
let priceSliderInitAttempts = 0;
const MAX_PRICE_SLIDER_ATTEMPTS = 3;
const initializedSliders = /* @__PURE__ */ new Map();
function autoInitializePriceSliders(savedState = null) {
  const containers = document.querySelectorAll(".filter-price-range-container");
  if (!containers || containers.length === 0) {
    return initializedSliders;
  }
  containers.forEach((container) => {
    const containerId = container.id || `price-slider-${Math.random().toString(36).substring(2, 9)}`;
    if (!container.id) {
      container.id = containerId;
    }
    try {
      let containerSavedState = null;
      if (savedState) {
        containerSavedState = savedState;
      }
      const slider = initializeSlider(container, containerSavedState);
      if (slider) {
        initializedSliders.set(containerId, slider);
        if (window.CollectionFilter) {
          window.CollectionFilter.priceSlider = slider;
        }
      }
    } catch (error) {
    }
  });
  return initializedSliders;
}
function initializeSlider(container, savedState = null) {
  const minCents = parseInt(container.dataset.minPrice || "0", 10);
  const maxCents = parseInt(container.dataset.maxPrice || "1000", 10);
  const min = minCents / 100;
  const max = maxCents / 100;
  let currentMin, currentMax;
  if (savedState && typeof savedState.min === "number") {
    currentMin = savedState.min;
    currentMax = savedState.max;
  } else {
    const currentMinCents = parseInt(container.dataset.currentMinPrice || minCents.toString(), 10);
    const currentMaxCents = parseInt(container.dataset.currentMaxPrice || maxCents.toString(), 10);
    currentMin = currentMinCents / 100;
    currentMax = currentMaxCents / 100;
  }
  const useAjaxFiltering = window.useAjaxFiltering === true && typeof window.AjaxCollectionManager !== "undefined";
  const slider = initPriceRangeSlider({
    container,
    min: Math.floor(min),
    max: Math.ceil(max),
    currentMin: Math.floor(currentMin),
    currentMax: Math.ceil(currentMax),
    onUpdate: (values) => {
      var _a;
      const collectionMain = document.querySelector(".collection-main");
      const showApplyButton = (collectionMain == null ? void 0 : collectionMain.getAttribute("data-show-filter-apply-button")) === "true";
      if (useAjaxFiltering && window.AjaxCollectionManager && !showApplyButton) {
        clearTimeout(window.priceSliderUpdateTimeout);
        window.priceSliderUpdateTimeout = setTimeout(() => {
          if (typeof window.AjaxCollectionManager.applyFilters === "function") {
            window.AjaxCollectionManager.applyFilters();
          }
        }, 500);
      }
      if (typeof ((_a = window.CollectionFilter) == null ? void 0 : _a.updateFilterActionsVisibility) === "function") {
        window.CollectionFilter.updateFilterActionsVisibility();
      }
    }
  });
  return slider;
}
function initPriceRangeSlider(options = {}) {
  const container = options.container;
  if (!container) {
    return false;
  }
  const min = typeof options.min === "number" ? options.min : 0;
  const max = typeof options.max === "number" ? options.max : 1e3;
  const currentMin = typeof options.currentMin === "number" ? options.currentMin : min;
  const currentMax = typeof options.currentMax === "number" ? options.currentMax : max;
  const onUpdate = options.onUpdate || (() => {
  });
  createSliderUI(container, { min, max, currentMin, currentMax });
  return initSliderFunctionality(container, { min, max, currentMin, currentMax, onUpdate });
}
function createSliderUI(container, options) {
  if (container.querySelector(".price-slider-track")) {
    return;
  }
  const existingInputs = document.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]');
  existingInputs.forEach((input) => input.remove());
  const sliderElement = document.createElement("div");
  sliderElement.className = "price-slider-container";
  sliderElement.innerHTML = `
        <div class="price-slider-track">
            <div class="price-slider-progress"></div>
            <div class="price-slider-handle min" tabindex="0" role="slider" aria-valuemin="${options.min}" aria-valuemax="${options.max}" aria-valuenow="${options.currentMin}"></div>
            <div class="price-slider-handle max" tabindex="0" role="slider" aria-valuemin="${options.min}" aria-valuemax="${options.max}" aria-valuenow="${options.currentMax}"></div>
        </div>
        <div class="price-slider-values">
            <div class="price-slider-value min">
                <span class="currency-symbol">$</span>
                <span class="value">${Math.floor(options.currentMin)}</span>
            </div>
            <div class="price-slider-value max">
                <span class="currency-symbol">$</span>
                <span class="value">${Math.ceil(options.currentMax)}</span>
            </div>
        </div>

        <!-- Hidden inputs for form submission - use whole dollar values for Shopify -->
        <input type="hidden" name="filter.v.price.gte" value="${Math.floor(options.currentMin)}">
        <input type="hidden" name="filter.v.price.lte" value="${Math.ceil(options.currentMax)}">
    `;
  container.prepend(sliderElement);
  const placeholder = container.querySelector(".filter-price-range-placeholder");
  if (placeholder) {
    placeholder.remove();
  }
}
function initSliderFunctionality(container, options) {
  const track = container.querySelector(".price-slider-track");
  const progress = container.querySelector(".price-slider-progress");
  const minHandle = container.querySelector(".price-slider-handle.min");
  const maxHandle = container.querySelector(".price-slider-handle.max");
  const minValueDisplay = container.querySelector(".price-slider-value.min .value");
  const maxValueDisplay = container.querySelector(".price-slider-value.max .value");
  const minInput = container.querySelector('input[name="filter.v.price.gte"]');
  const maxInput = container.querySelector('input[name="filter.v.price.lte"]');
  if (!track || !progress || !minHandle || !maxHandle) {
    return false;
  }
  let isDragging = false;
  let currentHandle = null;
  let minValue = options.currentMin;
  let maxValue = options.currentMax;
  const range = options.max - options.min;
  updateHandlePositions();
  function updateHandlePositions() {
    const minPercent = (minValue - options.min) / range * 100;
    const maxPercent = (maxValue - options.min) / range * 100;
    minHandle.style.left = `${minPercent}%`;
    maxHandle.style.left = `${maxPercent}%`;
    progress.style.left = `${minPercent}%`;
    progress.style.width = `${maxPercent - minPercent}%`;
    minHandle.setAttribute("aria-valuenow", minValue);
    maxHandle.setAttribute("aria-valuenow", maxValue);
    minValueDisplay.textContent = Math.floor(minValue);
    maxValueDisplay.textContent = Math.ceil(maxValue);
    minInput.value = Math.floor(minValue);
    maxInput.value = Math.ceil(maxValue);
  }
  function positionToValue(position) {
    const trackRect = track.getBoundingClientRect();
    const percent = Math.max(0, Math.min(1, (position - trackRect.left) / trackRect.width));
    const value = percent * range + options.min;
    return value;
  }
  function handleStart(e, handle) {
    e.preventDefault();
    isDragging = true;
    currentHandle = handle;
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("touchmove", handleMove, { passive: false });
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchend", handleEnd);
    handle.classList.add("active");
  }
  function handleMove(e) {
    if (!isDragging) return;
    const pointerX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    let newValue = positionToValue(pointerX);
    if (currentHandle === minHandle) {
      newValue = Math.min(maxValue - 0.01, newValue);
      minValue = newValue;
    } else {
      newValue = Math.max(minValue + 0.01, newValue);
      maxValue = newValue;
    }
    updateHandlePositions();
    if (e.type.includes("touch")) {
      e.preventDefault();
    }
  }
  function handleEnd() {
    if (!isDragging) return;
    document.removeEventListener("mousemove", handleMove);
    document.removeEventListener("touchmove", handleMove);
    document.removeEventListener("mouseup", handleEnd);
    document.removeEventListener("touchend", handleEnd);
    currentHandle.classList.remove("active");
    isDragging = false;
    options.onUpdate({
      min: Math.floor(minValue),
      max: Math.ceil(maxValue),
      minDollar: Math.floor(minValue),
      maxDollar: Math.ceil(maxValue)
    });
  }
  function handleKeydown(e, handle) {
    const step = Math.max(0.01, Math.round(range / 100 * 100) / 100);
    let newValue = handle === minHandle ? minValue : maxValue;
    switch (e.key) {
      case "ArrowLeft":
      case "ArrowDown":
        newValue = Math.max(handle === minHandle ? options.min : minValue + 0.01, newValue - step);
        break;
      case "ArrowRight":
      case "ArrowUp":
        newValue = Math.min(handle === minHandle ? maxValue - 0.01 : options.max, newValue + step);
        break;
      case "Home":
        newValue = handle === minHandle ? options.min : minValue + 0.01;
        break;
      case "End":
        newValue = handle === minHandle ? maxValue - 0.01 : options.max;
        break;
      default:
        return;
    }
    e.preventDefault();
    if (handle === minHandle) {
      minValue = newValue;
    } else {
      maxValue = newValue;
    }
    updateHandlePositions();
    options.onUpdate({
      min: Math.floor(minValue),
      max: Math.ceil(maxValue),
      minDollar: Math.floor(minValue),
      maxDollar: Math.ceil(maxValue)
    });
  }
  minHandle.addEventListener("mousedown", (e) => handleStart(e, minHandle));
  minHandle.addEventListener("touchstart", (e) => handleStart(e, minHandle), { passive: false });
  maxHandle.addEventListener("mousedown", (e) => handleStart(e, maxHandle));
  maxHandle.addEventListener("touchstart", (e) => handleStart(e, maxHandle), { passive: false });
  minHandle.addEventListener("keydown", (e) => handleKeydown(e, minHandle));
  maxHandle.addEventListener("keydown", (e) => handleKeydown(e, maxHandle));
  track.addEventListener("click", (e) => {
    if (isDragging) return;
    const clickValue = positionToValue(e.clientX);
    const minDistance = Math.abs(clickValue - minValue);
    const maxDistance = Math.abs(clickValue - maxValue);
    if (minDistance <= maxDistance) {
      minValue = Math.min(maxValue - 0.01, clickValue);
    } else {
      maxValue = Math.max(minValue + 0.01, clickValue);
    }
    updateHandlePositions();
    options.onUpdate({
      min: Math.floor(minValue),
      max: Math.ceil(maxValue),
      minDollar: Math.floor(minValue),
      maxDollar: Math.ceil(maxValue)
    });
  });
  return {
    updateValues: (min, max) => {
      minValue = typeof min === "number" ? min : options.min;
      maxValue = typeof max === "number" ? max : options.max;
      updateHandlePositions();
    },
    getValues: () => ({
      min: minValue,
      max: maxValue,
      minDollar: Math.floor(minValue),
      maxDollar: Math.ceil(maxValue)
    }),
    reset: () => {
      minValue = options.min;
      maxValue = options.max;
      updateHandlePositions();
      options.onUpdate({
        min: Math.floor(minValue),
        max: Math.ceil(maxValue),
        minDollar: Math.floor(minValue),
        maxDollar: Math.ceil(maxValue)
      });
    },
    destroy: () => {
      minHandle.removeEventListener("mousedown", handleStart);
      minHandle.removeEventListener("touchstart", handleStart);
      maxHandle.removeEventListener("mousedown", handleStart);
      maxHandle.removeEventListener("touchstart", handleStart);
      minHandle.removeEventListener("keydown", handleKeydown);
      maxHandle.removeEventListener("keydown", handleKeydown);
      track.removeEventListener("click", handleMove);
    }
  };
}
function resetAllSliders() {
  initializedSliders.forEach((slider) => {
    if (slider && typeof slider.reset === "function") {
      slider.reset();
    }
  });
}
function getSlider(id) {
  const actualId = id.startsWith("#") ? id.substring(1) : id;
  return initializedSliders.get(actualId) || null;
}
function initializePriceSlidersWithRetry(savedState = null) {
  if (isPriceSliderInitialized) {
    return Promise.resolve(initializedSliders);
  }
  const sliders = autoInitializePriceSliders(savedState);
  if (sliders.size === 0 && priceSliderInitAttempts < MAX_PRICE_SLIDER_ATTEMPTS) {
    priceSliderInitAttempts++;
    return new Promise((resolve) => {
      setTimeout(() => {
        initializePriceSlidersWithRetry(savedState).then(resolve);
      }, 500);
    });
  } else if (sliders.size > 0) {
    isPriceSliderInitialized = true;
    priceSliderInitAttempts = 0;
  }
  return Promise.resolve(sliders);
}
function setupPriceSliderInitializers() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializePriceSlidersWithRetry();
    });
  } else {
    initializePriceSlidersWithRetry();
  }
  window.addEventListener("load", () => {
    if (!isPriceSliderInitialized) {
      initializePriceSlidersWithRetry();
    }
  });
  document.addEventListener("criticalReady", () => {
    if (!isPriceSliderInitialized) {
      initializePriceSlidersWithRetry();
    }
  });
}
setupPriceSliderInitializers();
if (window.Shopify && window.Shopify.designMode !== true) {
  setTimeout(() => {
    const priceSliderContainer = document.querySelector(".filter-price-range-container");
    if (priceSliderContainer && !isPriceSliderInitialized) {
      initializePriceSlidersWithRetry();
    }
  }, 1e3);
}
window.CollectionFilter = {
  initFilterOptionsStyling,
  initFilterFormHandlers,
  initFilterVisibility,
  updateFilterCounts,
  initFilterGroupsState,
  initFilterActionsVisibility,
  updateFilterActionsVisibility,
  initPriceRangeSlider,
  autoInitializePriceSliders,
  resetAllSliders,
  getSlider
};
function initFilterDrawer() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFilterDrawerInternal);
  } else {
    initFilterDrawerInternal();
  }
}
function initFilterDrawerInternal() {
  const drawerElement = document.querySelector("[data-collection-filter-drawer]");
  const drawer = drawerElement == null ? void 0 : drawerElement.drawer;
  if (!drawer) {
    return;
  }
  const filterBtn = document.getElementById("collectionFilterBtn");
  if (filterBtn && drawer) {
    filterBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (drawer && typeof drawer.open === "function") {
        drawer.open();
        filterBtn.setAttribute("aria-expanded", "true");
      }
    });
    if (drawer && typeof drawer.on === "function") {
      drawer.on("close", () => {
        filterBtn.setAttribute("aria-expanded", "false");
      });
    }
  }
  const useAjaxFiltering = window.useAjaxFiltering === true;
  if (!useAjaxFiltering) {
    const filterForm = document.getElementById("FilterDrawerForm");
    if (filterForm) {
      const newForm = filterForm.cloneNode(true);
      filterForm.parentNode.replaceChild(newForm, filterForm);
    }
    initFilterFormHandlers(drawer);
  }
  initFilterOptionsStyling();
  initFilterVisibility();
  initFilterGroupsState();
  document.querySelector(".filter-actions");
  initFilterActionsVisibility();
  const priceSliders = autoInitializePriceSliders();
  priceSliders && priceSliders.size > 0;
}
class AjaxCollectionManager {
  constructor() {
    this.isLoading = false;
    this.productGrid = null;
    this.paginationElement = null;
    this.filterForm = null;
    this.sortDropdown = null;
    this.loadingIndicator = null;
    this.hasPopStateListener = false;
    this.loadingTimeout = null;
    this.init();
  }
  /**
   * Initialize the AJAX collection manager
   */
  init() {
    this.productGrid = window.DOMHelper.safeQuery("#product-grid") || window.DOMHelper.safeQuery('[id^="collection-grid-"]') || window.DOMHelper.safeQuery('[id^="search-results-"]');
    this.paginationElement = window.DOMHelper.safeQuery("#AjaxinatePagination");
    this.filterForm = window.DOMHelper.safeQuery("#FilterDrawerForm");
    this.sortDropdown = window.DOMHelper.safeQuery("#sortDropdownContent");
    if (!this.productGrid || !this.filterForm) {
      return;
    }
    this.initLoadingIndicator();
    this.setupEventListeners();
  }
  /**
   * Initialize the loading indicator
   */
  initLoadingIndicator() {
    var _a, _b, _c;
    if (window.DOMHelper.safeQuery(".filter-loading-indicator")) return;
    const loadingIndicator = window.DOMHelper.createElement("div", {
      className: "filter-loading-indicator",
      styles: { display: "none" }
    });
    const translations = ((_c = (_b = (_a = window.theme) == null ? void 0 : _a.translations) == null ? void 0 : _b.general) == null ? void 0 : _c.predictive_search) || {};
    loadingIndicator.textContent = translations.loading || "Loading...";
    const drawerHeader = window.DOMHelper.safeQuery("[data-collection-filter-drawer] .drawer-header");
    if (drawerHeader) {
      drawerHeader.appendChild(loadingIndicator);
    }
    window.showFilterLoading = () => {
      const indicator = window.DOMHelper.safeQuery(".filter-loading-indicator");
      if (indicator) {
        window.DOMHelper.setStyle(indicator, "display", "block");
      }
    };
    window.hideFilterLoading = () => {
      const indicator = window.DOMHelper.safeQuery(".filter-loading-indicator");
      if (indicator) {
        window.DOMHelper.setStyle(indicator, "display", "none");
      }
    };
  }
  /**
   * Set up event listeners for filtering and sorting
   */
  setupEventListeners() {
    this.removeEventListeners();
    this.filterForm.addEventListener("submit", this.handleFormSubmit = (e) => {
      e.preventDefault();
      this.applyFilters();
    });
    const resetButton = window.DOMHelper.safeQuery('button[type="reset"]', this.filterForm);
    if (resetButton) {
      resetButton.addEventListener("click", this.handleReset = (e) => {
        e.preventDefault();
        this.resetFilters();
      });
    }
    const checkboxes = window.DOMHelper.safeQueryAll('input[type="checkbox"]', this.filterForm);
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange = () => {
        const collectionMain = window.DOMHelper.safeQuery(".collection-main");
        const showApplyButton = window.DOMHelper.getAttribute(collectionMain, "data-show-filter-apply-button") === "true";
        if (!showApplyButton) {
          this.debounce(() => this.applyFilters(), 500)();
        }
      });
    });
    if (this.sortDropdown) {
      const sortLinks = window.DOMHelper.safeQueryAll("a", this.sortDropdown);
      sortLinks.forEach((link) => {
        link.addEventListener("click", this.handleSortClick = (e) => {
          e.preventDefault();
          this.applySorting(window.DOMHelper.getAttribute(link, "data-value"));
        });
      });
    }
    if (!this.hasPopStateListener) {
      window.addEventListener("popstate", this.handlePopState = () => {
        this.fetchAndUpdateContent(window.location.href);
      });
      this.hasPopStateListener = true;
    }
  }
  /**
   * Remove event listeners to prevent duplicates
   */
  removeEventListeners() {
    if (this.filterForm) {
      if (this.handleFormSubmit) {
        this.filterForm.removeEventListener("submit", this.handleFormSubmit);
      }
      const resetButton = window.DOMHelper.safeQuery('button[type="reset"]', this.filterForm);
      if (resetButton && this.handleReset) {
        resetButton.removeEventListener("click", this.handleReset);
      }
      const checkboxes = window.DOMHelper.safeQueryAll('input[type="checkbox"]', this.filterForm);
      if (this.handleCheckboxChange) {
        checkboxes.forEach((checkbox) => {
          checkbox.removeEventListener("change", this.handleCheckboxChange);
        });
      }
    }
    if (this.sortDropdown && this.handleSortClick) {
      const sortLinks = window.DOMHelper.safeQueryAll("a", this.sortDropdown);
      sortLinks.forEach((link) => {
        link.removeEventListener("click", this.handleSortClick);
      });
    }
  }
  /**
   * Apply filters
   */
  applyFilters() {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.isLoading) return;
      this.setLoadingState();
      (_a = window.showFilterLoading) == null ? void 0 : _a.call(window);
      try {
        const formData = new FormData(this.filterForm);
        const searchParams = new URLSearchParams();
        const currentUrl = new URL(window.location.href);
        for (const [key, value] of formData.entries()) {
          if (value) searchParams.append(key, value);
        }
        if (currentUrl.searchParams.has("sort_by")) {
          searchParams.set("sort_by", currentUrl.searchParams.get("sort_by"));
        }
        if (currentUrl.searchParams.has("q")) {
          searchParams.set("q", currentUrl.searchParams.get("q"));
        }
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.pushState({ path: newUrl }, "", newUrl);
        setTimeout(() => {
          var _a2;
          if (typeof ((_a2 = window.CollectionFilter) == null ? void 0 : _a2.updateFilterActionsVisibility) === "function") {
            window.CollectionFilter.updateFilterActionsVisibility();
          }
        }, 100);
        yield this.fetchAndUpdateContent(newUrl);
      } catch (error) {
        this.clearLoadingState();
      } finally {
        (_b = window.hideFilterLoading) == null ? void 0 : _b.call(window);
      }
    });
  }
  /**
   * Reset filters
   */
  resetFilters() {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.isLoading) return;
      this.setLoadingState();
      (_a = window.showFilterLoading) == null ? void 0 : _a.call(window);
      try {
        this.filterForm.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
          checkbox.checked = false;
        });
        if (window.CollectionFilter && typeof window.CollectionFilter.resetAllSliders === "function") {
          window.CollectionFilter.resetAllSliders();
        }
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams();
        if (currentUrl.searchParams.has("q")) {
          searchParams.set("q", currentUrl.searchParams.get("q"));
        }
        const newUrl = searchParams.toString() ? `${window.location.pathname}?${searchParams.toString()}` : window.location.pathname;
        window.history.pushState({ path: newUrl }, "", newUrl);
        yield this.fetchAndUpdateContent(newUrl);
        setTimeout(() => {
          var _a2;
          if (typeof ((_a2 = window.CollectionFilter) == null ? void 0 : _a2.updateFilterActionsVisibility) === "function") {
            window.CollectionFilter.updateFilterActionsVisibility();
          }
        }, 100);
      } catch (error) {
        this.clearLoadingState();
      } finally {
        (_b = window.hideFilterLoading) == null ? void 0 : _b.call(window);
      }
    });
  }
  /**
   * Apply sorting
   */
  applySorting(sortValue) {
    return __async(this, null, function* () {
      if (this.isLoading) return;
      this.setLoadingState();
      try {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("sort_by", sortValue);
        window.history.pushState({ path: currentUrl.href }, "", currentUrl.href);
        yield this.fetchAndUpdateContent(currentUrl.href);
        this.updateSortDropdownText(sortValue);
      } catch (error) {
        this.clearLoadingState();
      }
    });
  }
  /**
   * Fetch and update content
   */
  fetchAndUpdateContent(url) {
    return __async(this, null, function* () {
      try {
        window.DOMHelper.addClass(this.productGrid, "ajax-loading");
        requestAnimationFrame(() => {
          window.DOMHelper.addClass(this.productGrid, "is-active");
        });
        const currentStates = this.captureCurrentStates();
        const response = yield window.ShopifyAPIHelper.safeFetch(url);
        const html = yield response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const gridId = window.DOMHelper.getAttribute(this.productGrid, "id");
        const newGrid = window.DOMHelper.safeQuery(`#${gridId}`, doc) || window.DOMHelper.safeQuery('[id^="collection-grid-"]', doc) || window.DOMHelper.safeQuery('[id^="search-results-"]', doc);
        const newPagination = window.DOMHelper.safeQuery("#AjaxinatePagination", doc);
        const newFilterDrawer = window.DOMHelper.safeQuery(".collection-filter-drawer-content", doc);
        if (!newGrid) throw new Error("New product grid not found");
        window.DOMHelper.replaceContent(this.productGrid, newGrid.innerHTML);
        if (this.paginationElement && newPagination) {
          window.DOMHelper.replaceContent(this.paginationElement, newPagination.innerHTML);
        }
        if (newFilterDrawer) {
          yield this.updateFilterDrawer(newFilterDrawer, currentStates);
        }
        this.initializeComponents();
      } catch (error) {
        this.clearLoadingState();
        window.location.href = url;
      }
    });
  }
  /**
   * Capture current states before update
   */
  captureCurrentStates() {
    const states = {
      expandedGroups: /* @__PURE__ */ new Set(),
      checkboxStates: /* @__PURE__ */ new Map(),
      filterCounts: /* @__PURE__ */ new Map(),
      priceRange: null
    };
    const filterDrawer = window.DOMHelper.safeQuery(".collection-filter-drawer-content");
    if (!filterDrawer) return states;
    const filterGroups = window.DOMHelper.safeQueryAll(".filter-group-details", filterDrawer);
    filterGroups.forEach((group, index) => {
      if (window.DOMHelper.hasAttribute(group, "open")) {
        states.expandedGroups.add(index);
      }
    });
    const filterOptions = window.DOMHelper.safeQueryAll(".filter-option", filterDrawer);
    filterOptions.forEach((option) => {
      const checkbox = window.DOMHelper.safeQuery('input[type="checkbox"]', option);
      const countEl = window.DOMHelper.safeQuery(".filter-count", option);
      if (checkbox) {
        const name = window.DOMHelper.getAttribute(checkbox, "name");
        states.checkboxStates.set(name, checkbox.checked);
      }
      if (checkbox && countEl) {
        const name = window.DOMHelper.getAttribute(checkbox, "name");
        const count = parseInt(countEl.textContent.replace(/[^0-9]/g, ""), 10) || 0;
        states.filterCounts.set(name, count);
      }
    });
    if (window.CollectionFilter && typeof window.CollectionFilter.getSlider === "function") {
      const priceSliderContainer = window.DOMHelper.safeQuery(".filter-price-range-container");
      if (priceSliderContainer) {
        const containerId = window.DOMHelper.getAttribute(priceSliderContainer, "id");
        if (containerId) {
          const slider = window.CollectionFilter.getSlider(containerId);
          if (slider && typeof slider.getValues === "function") {
            states.priceRange = slider.getValues();
          }
        }
      }
    }
    return states;
  }
  /**
   * Update filter drawer with new content while preserving states
   */
  updateFilterDrawer(newFilterDrawer, currentStates) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e;
      const currentFilterDrawer = window.DOMHelper.safeQuery(".collection-filter-drawer-content");
      if (!currentFilterDrawer) return;
      window.DOMHelper.replaceContent(currentFilterDrawer, newFilterDrawer.innerHTML);
      this.filterForm = window.DOMHelper.safeQuery("#FilterDrawerForm");
      if (typeof ((_a = window.CollectionFilter) == null ? void 0 : _a.initFilterVisibility) === "function") {
        window.CollectionFilter.initFilterVisibility();
      }
      if (typeof ((_b = window.CollectionFilter) == null ? void 0 : _b.initFilterGroupsState) === "function") {
        window.CollectionFilter.initFilterGroupsState(true);
      }
      if (typeof ((_c = window.CollectionFilter) == null ? void 0 : _c.initFilterOptionsStyling) === "function") {
        window.CollectionFilter.initFilterOptionsStyling();
      }
      setTimeout(() => {
        var _a2;
        if (typeof ((_a2 = window.CollectionFilter) == null ? void 0 : _a2.initFilterActionsVisibility) === "function") {
          window.CollectionFilter.initFilterActionsVisibility();
        }
      }, 100);
      if (currentStates.priceRange) {
        if (typeof ((_d = window.CollectionFilter) == null ? void 0 : _d.autoInitializePriceSliders) === "function") {
          window.CollectionFilter.autoInitializePriceSliders(currentStates.priceRange);
        }
      } else {
        if (typeof ((_e = window.CollectionFilter) == null ? void 0 : _e.autoInitializePriceSliders) === "function") {
          window.CollectionFilter.autoInitializePriceSliders();
        }
      }
      this.setupEventListeners();
    });
  }
  /**
   * Initialize components after content update
   */
  initializeComponents() {
    var _a, _b, _c, _d, _e;
    if (typeof ((_a = window.CollectionFilter) == null ? void 0 : _a.initFilterVisibility) === "function") {
      window.CollectionFilter.initFilterVisibility();
    }
    if (typeof ((_b = window.CollectionFilter) == null ? void 0 : _b.initFilterGroupsState) === "function") {
      window.CollectionFilter.initFilterGroupsState(true);
    }
    if (typeof ((_c = window.CollectionFilter) == null ? void 0 : _c.initFilterOptionsStyling) === "function") {
      window.CollectionFilter.initFilterOptionsStyling();
    }
    if (typeof ((_d = window.CollectionFilter) == null ? void 0 : _d.initFilterActionsVisibility) === "function") {
      window.CollectionFilter.initFilterActionsVisibility();
    } else if (typeof ((_e = window.CollectionFilter) == null ? void 0 : _e.updateFilterActionsVisibility) === "function") {
      window.CollectionFilter.updateFilterActionsVisibility();
    }
    if (typeof window.initializeProductCards === "function") {
      window.initializeProductCards();
    }
    if (typeof window.initializeImageLoading === "function") {
      window.initializeImageLoading(this.productGrid);
    }
    if (typeof window.initGlobalAjaxinate === "function") {
      window.initGlobalAjaxinate(this.productGrid.id);
    }
    this.setupEventListeners();
    setTimeout(() => {
      this.clearLoadingState();
      setTimeout(() => {
        window.DOMHelper.dispatchEvent("theme:products:loaded");
        window.DOMHelper.dispatchEvent("theme:collection:updated");
        window.DOMHelper.dispatchEvent("collection:grid:update");
        window.DOMHelper.dispatchEvent("collection:updated");
        setTimeout(() => {
          window.DOMHelper.dispatchEvent("collectionUpdate:complete");
        }, 350);
      }, 50);
    }, 100);
  }
  /**
   * Update sort dropdown text
   */
  updateSortDropdownText(sortValue) {
    const sortButton = window.DOMHelper.safeQuery("#collectionSortBtn");
    const sortLabel = window.DOMHelper.safeQuery(".sort-label", sortButton);
    if (!sortLabel || !this.sortDropdown) return;
    const sortLinks = window.DOMHelper.safeQueryAll("a", this.sortDropdown);
    sortLinks.forEach((link) => {
      const linkValue = window.DOMHelper.getAttribute(link, "data-value");
      if (linkValue === sortValue) {
        sortLabel.textContent = link.textContent.trim();
        window.DOMHelper.addClass(link, "active");
        window.DOMHelper.setAttribute(link, "aria-current", "true");
      } else {
        window.DOMHelper.removeClass(link, "active");
        window.DOMHelper.removeAttribute(link, "aria-current");
      }
    });
  }
  /**
   * Simple debounce function
   */
  debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
  /**
   * Failsafe method to clear any stuck loading states with proper fade
   */
  clearLoadingState() {
    if (this.productGrid) {
      window.DOMHelper.removeClass(this.productGrid, "is-active");
      setTimeout(() => {
        if (this.productGrid) {
          window.DOMHelper.removeClass(this.productGrid, "ajax-loading");
        }
      }, 300);
    }
    this.isLoading = false;
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
    if (typeof window.hideFilterLoading === "function") {
      window.hideFilterLoading();
    }
  }
  /**
   * Set loading state with automatic timeout failsafe
   */
  setLoadingState() {
    this.isLoading = true;
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
    this.loadingTimeout = setTimeout(() => {
      this.resetLoadingState();
    }, 1e4);
  }
}
function initAjaxCollectionManager() {
  const template = window.DOMHelper.getAttribute(document.body, "data-template");
  const isCollectionPage = template === "collection";
  const isSearchPage = template === "search";
  if (isCollectionPage || isSearchPage) {
    if (!window.AjaxCollectionManager) {
      window.AjaxCollectionManager = new AjaxCollectionManager();
      window.useAjaxFiltering = true;
      window.clearAjaxLoadingState = () => {
        if (window.AjaxCollectionManager) {
          window.AjaxCollectionManager.clearLoadingState();
        }
      };
    }
  }
}
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("AjaxCollectionManager", initAjaxCollectionManager, ["DOMHelper"]);
} else {
  document.addEventListener("DOMContentLoaded", initAjaxCollectionManager);
  document.addEventListener("criticalReady", initAjaxCollectionManager);
}
class StickyFilterVertical {
  constructor() {
    this.filterWrapper = null;
    this.headerRight = null;
    this.isEnabled = false;
    this.lastScrollY = window.scrollY;
    this.isHidden = false;
    this.hideOnScroll = false;
    this.announcementBar = null;
    this.ticking = false;
    this.resizeTimeout = null;
    this.isFixedHeader = false;
    this.isTransparentBackground = false;
    this.init();
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setup());
    } else {
      this.setup();
    }
  }
  setup() {
    var _a;
    this.filterWrapper = document.querySelector(".collection-filter-wrapper");
    this.headerRight = document.querySelector("#header-right");
    this.announcementBar = document.querySelector(".announcement-bar-container");
    if (!this.filterWrapper || !this.headerRight) return;
    const collectionMain = document.querySelector(".collection-main");
    this.isEnabled = (collectionMain == null ? void 0 : collectionMain.dataset.enableSticky) === "true";
    this.hideOnScroll = ((_a = this.announcementBar) == null ? void 0 : _a.getAttribute("data-hide-on-scroll")) === "true";
    this.isFixedHeader = document.body.getAttribute("data-fixed-header") === "true";
    this.isTransparentBackground = document.body.getAttribute("data-transparent-background") === "true";
    if (this.isEnabled) {
      this.setupStickyFilter();
      this.setupEventListeners();
    }
  }
  setupStickyFilter() {
    this.filterWrapper.style.position = "sticky";
    this.filterWrapper.style.top = `${this.getVerticalOffset()}px`;
    this.filterWrapper.style.zIndex = "40";
    this.filterWrapper.style.transition = "transform 0.3s ease-in-out";
    this.filterWrapper.style.width = "100%";
    if (!this.isTransparentBackground) {
      this.filterWrapper.style.backgroundColor = "rgb(var(--primary-background-color))";
    } else {
      this.filterWrapper.style.backgroundColor = "transparent";
    }
    this.filterWrapper.style.willChange = "transform";
  }
  setupEventListeners() {
    let scheduledAnimationFrame = false;
    const onScroll = () => {
      if (!scheduledAnimationFrame) {
        scheduledAnimationFrame = true;
        window.requestAnimationFrame(() => {
          this.handleScroll();
          scheduledAnimationFrame = false;
        });
      }
    };
    if (window.globalThrottleManager) {
      window.globalThrottleManager.onScroll("sticky-filter-vertical", onScroll);
      window.globalThrottleManager.onResize("sticky-filter-vertical", () => {
        if (this.resizeTimeout) {
          window.cancelAnimationFrame(this.resizeTimeout);
        }
        this.resizeTimeout = window.requestAnimationFrame(() => {
          this.handleResize();
          this.resizeTimeout = null;
        });
      });
    } else {
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", () => {
        if (this.resizeTimeout) {
          window.cancelAnimationFrame(this.resizeTimeout);
        }
        this.resizeTimeout = window.requestAnimationFrame(() => {
          this.handleResize();
          this.resizeTimeout = null;
        });
      }, { passive: true });
    }
    document.addEventListener("announcement:hidden", () => this.updateStickyPosition());
    document.addEventListener("announcement:visible", () => this.updateStickyPosition());
    document.addEventListener("menuOpenManualOverride", () => this.handleMenuOverride(true));
    document.addEventListener("menuCloseManualOverride", () => this.handleMenuOverride(false));
  }
  getAnnouncementHeight() {
    if (!this.announcementBar) return 0;
    return this.announcementBar.offsetHeight;
  }
  getVerticalOffset() {
    if (!this.isFixedHeader) return 0;
    let offset = this.headerRight.offsetHeight + 6;
    if (this.hideOnScroll) {
      if (window.scrollY <= 50) {
        offset += this.getAnnouncementHeight();
      }
    } else {
      offset += this.getAnnouncementHeight();
    }
    return offset;
  }
  handleScroll() {
    if (!this.isEnabled) return;
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.lastScrollY;
    const scrollThreshold = 50;
    const showThreshold = 200;
    if (!this.isFixedHeader) {
      this.filterWrapper.style.transform = "translateY(0)";
      this.isHidden = false;
    } else if (this.hideOnScroll) {
      if (currentScrollY > scrollThreshold) {
        if (scrollingDown && !this.isHidden) {
          this.filterWrapper.style.transform = "translateY(-100%)";
          this.isHidden = true;
        } else if (!scrollingDown && currentScrollY <= showThreshold && this.isHidden) {
          this.filterWrapper.style.transform = "translateY(0)";
          this.isHidden = false;
        }
      } else {
        this.filterWrapper.style.transform = "translateY(0)";
        this.isHidden = false;
      }
    } else {
      this.filterWrapper.style.transform = "translateY(0)";
      this.isHidden = false;
    }
    this.updateStickyPosition();
    this.lastScrollY = currentScrollY;
  }
  handleResize() {
    if (!this.isEnabled) return;
    this.updateStickyPosition();
  }
  updateStickyPosition() {
    if (!this.isEnabled) return;
    this.filterWrapper.style.top = `${this.getVerticalOffset()}px`;
  }
  handleMenuOverride(isOpen) {
    if (!this.isEnabled) return;
    if (isOpen) {
      this.filterWrapper.style.transform = "translateX(50px)";
    } else {
      this.filterWrapper.style.transform = "translateX(0)";
    }
  }
}
new StickyFilterVertical();
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, () => {
      setTimeout(() => {
        new StickyFilterVertical();
      }, 0);
    });
  });
}
class StickyFilterDefault {
  constructor() {
    this.filterWrapper = null;
    this.headerContainer = null;
    this.isEnabled = false;
    this.lastScrollY = window.scrollY;
    this.isHidden = false;
    this.hideOnScroll = false;
    this.isFixedHeader = false;
    this.isTransparentBackground = false;
    this.init();
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setup());
    } else {
      this.setup();
    }
  }
  setup() {
    this.filterWrapper = document.querySelector(".collection-filter-wrapper");
    this.headerContainer = document.querySelector(".header-container");
    if (!this.filterWrapper || !this.headerContainer) return;
    const collectionMain = document.querySelector(".collection-main");
    this.isEnabled = (collectionMain == null ? void 0 : collectionMain.dataset.enableSticky) === "true";
    const announcementBar = document.querySelector(".announcement-bar-container");
    this.hideOnScroll = (announcementBar == null ? void 0 : announcementBar.getAttribute("data-hide-on-scroll")) === "true";
    this.isFixedHeader = document.body.getAttribute("data-fixed-header") === "true";
    this.isTransparentBackground = document.body.getAttribute("data-transparent-background") === "true";
    if (this.isEnabled) {
      this.setupStickyFilter();
      this.setupEventListeners();
    }
  }
  setupStickyFilter() {
    this.filterWrapper.style.position = "sticky";
    this.filterWrapper.style.top = this.isFixedHeader ? `${this.headerContainer.offsetHeight + 6}px` : "0";
    this.filterWrapper.style.zIndex = "40";
    this.filterWrapper.style.transition = "transform 0.3s ease-in-out";
    if (!this.isTransparentBackground) {
      this.filterWrapper.style.backgroundColor = "rgb(var(--primary-background-color))";
    } else {
      this.filterWrapper.style.backgroundColor = "transparent";
    }
  }
  setupEventListeners() {
    if (window.globalThrottleManager) {
      window.globalThrottleManager.onScroll("sticky-filter-default", () => this.handleScroll());
      window.globalThrottleManager.onResize("sticky-filter-default", () => this.handleResize());
    } else {
      window.addEventListener("scroll", () => this.handleScroll(), { passive: true });
      window.addEventListener("resize", () => this.handleResize(), { passive: true });
    }
    document.addEventListener("announcement:hidden", () => this.updateStickyPosition());
    document.addEventListener("announcement:visible", () => this.updateStickyPosition());
  }
  handleScroll() {
    if (!this.isEnabled) return;
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.lastScrollY;
    const scrollThreshold = 50;
    const showThreshold = 200;
    if (!this.isFixedHeader) {
      this.filterWrapper.style.transform = "translateY(0)";
      this.isHidden = false;
    } else if (this.hideOnScroll) {
      if (currentScrollY > scrollThreshold) {
        if (scrollingDown && !this.isHidden) {
          this.filterWrapper.style.transform = "translateY(-100%)";
          this.isHidden = true;
        } else if (!scrollingDown && currentScrollY <= showThreshold && this.isHidden) {
          this.filterWrapper.style.transform = "translateY(0)";
          this.isHidden = false;
        }
      } else {
        this.filterWrapper.style.transform = "translateY(0)";
        this.isHidden = false;
      }
    }
    this.lastScrollY = currentScrollY;
  }
  handleResize() {
    if (!this.isEnabled) return;
    this.updateStickyPosition();
  }
  updateStickyPosition() {
    if (!this.isEnabled) return;
    this.filterWrapper.style.top = this.isFixedHeader ? `${this.headerContainer.offsetHeight + 6}px` : "0";
  }
}
new StickyFilterDefault();
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, () => {
      setTimeout(() => {
        new StickyFilterDefault();
      }, 0);
    });
  });
}
class ViewToggle {
  constructor() {
    this.productGrid = null;
    this.normalViewBtn = null;
    this.quickViewBtn = null;
    this.currentView = "normal";
    this.originalGridClasses = "";
    this.isTransitioning = false;
    this.init();
  }
  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.setup());
    } else {
      this.setup();
    }
  }
  setup() {
    this.productGrid = window.DOMHelper.safeQuery('[id^="collection-grid-"], [id^="search-results-"]');
    this.normalViewBtn = window.DOMHelper.safeQuery("#normalViewBtn");
    this.quickViewBtn = window.DOMHelper.safeQuery("#quickViewBtn");
    if (!this.productGrid || !this.normalViewBtn || !this.quickViewBtn) {
      return;
    }
    this.originalGridClasses = this.productGrid.className;
    this.currentView = "normal";
    this.setView("normal");
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.normalViewBtn.addEventListener("click", () => this.setView("normal"));
    this.quickViewBtn.addEventListener("click", () => this.setView("quick"));
  }
  setView(viewMode) {
    if (!this.productGrid) {
      return;
    }
    if (window.AjaxCollectionManager && window.AjaxCollectionManager.isLoading) {
      return;
    }
    if (this.isTransitioning) {
      return;
    }
    if (this.currentView === viewMode) {
      return;
    }
    this.isTransitioning = true;
    window.DOMHelper.addClass(this.productGrid, "view-transitioning");
    setTimeout(() => {
      this.currentView = viewMode;
      window.DOMHelper.setAttribute(this.productGrid, "data-view-mode", viewMode);
      this.updateButtonStates();
      this.applyGridLayout();
      if (typeof window.updateProductGrid === "function") {
        window.updateProductGrid();
      }
      window.DOMHelper.removeClass(this.productGrid, "view-transitioning");
      setTimeout(() => {
        this.isTransitioning = false;
        window.DOMHelper.dispatchEvent("viewToggle:changed", {
          detail: { viewMode, productGrid: this.productGrid }
        });
      }, 400);
    }, 400);
  }
  updateButtonStates() {
    window.DOMHelper.removeClass(this.normalViewBtn, "active");
    window.DOMHelper.removeClass(this.quickViewBtn, "active");
    if (this.currentView === "normal") {
      window.DOMHelper.addClass(this.normalViewBtn, "active");
    } else {
      window.DOMHelper.addClass(this.quickViewBtn, "active");
    }
  }
  applyGridLayout() {
    if (!this.productGrid) return;
    this.productGrid.className = this.originalGridClasses;
    if (this.currentView === "quick") {
      const quickViewCols = window.DOMHelper.getAttribute(this.productGrid, "data-quick-view-columns") || "6";
      const quickViewMobileCols = window.DOMHelper.getAttribute(this.productGrid, "data-quick-view-mobile-columns") || "3";
      window.DOMHelper.addClass(this.productGrid, `quick-view-cols-${quickViewCols}`);
      window.DOMHelper.addClass(this.productGrid, `quick-view-mobile-cols-${quickViewMobileCols}`);
    }
  }
  // Public method to get current view mode
  getCurrentView() {
    return this.currentView;
  }
  // Public method to refresh the view toggle (useful for AJAX page updates)
  refresh() {
    this.applyGridLayout();
    this.updateButtonStates();
  }
  // Public method to destroy the instance (cleanup)
  destroy() {
    if (this.normalViewBtn) {
      this.normalViewBtn.removeEventListener("click", this.setView);
    }
    if (this.quickViewBtn) {
      this.quickViewBtn.removeEventListener("click", this.setView);
    }
  }
  // Public method to reset the instance (useful when DOM elements change completely)
  reset() {
    this.destroy();
    this.productGrid = null;
    this.normalViewBtn = null;
    this.quickViewBtn = null;
    this.currentView = "normal";
    this.originalGridClasses = "";
    this.isTransitioning = false;
    this.setup();
  }
}
let viewToggleInstance = null;
function initViewToggle() {
  if (viewToggleInstance) {
    return viewToggleInstance;
  }
  viewToggleInstance = new ViewToggle();
  return viewToggleInstance;
}
if (typeof window.ModuleManager !== "undefined") {
  window.ModuleManager.register("ViewToggle", initViewToggle, ["DOMHelper"]);
} else {
  document.addEventListener("DOMContentLoaded", () => {
    initViewToggle();
  });
}
document.addEventListener("collectionUpdate:complete", () => {
  var _a, _b, _c;
  if (window.AjaxCollectionManager && window.AjaxCollectionManager.isLoading) {
    return;
  }
  if (viewToggleInstance) {
    const productGrid = (_a = window.DOMHelper) == null ? void 0 : _a.safeQuery('[id^="collection-grid-"], [id^="search-results-"]');
    const normalViewBtn = (_b = window.DOMHelper) == null ? void 0 : _b.safeQuery("#normalViewBtn");
    const quickViewBtn = (_c = window.DOMHelper) == null ? void 0 : _c.safeQuery("#quickViewBtn");
    if (productGrid && normalViewBtn && quickViewBtn) {
      viewToggleInstance.refresh();
    } else {
      viewToggleInstance.reset();
    }
    return;
  }
  initViewToggle();
});
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  const themeEditorEvents = [
    "shopify:section:load",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect"
  ];
  themeEditorEvents.forEach((eventName) => {
    document.addEventListener(eventName, () => {
      setTimeout(() => {
        if (!viewToggleInstance) {
          initViewToggle();
        }
      }, 100);
    });
  });
}
class CollectionPagination {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.init();
  }
  init() {
    if (typeof Ajaxinate !== "undefined") {
      new Ajaxinate({
        container: `#CollectionGrid-${this.sectionId}`,
        pagination: "#AjaxinatePagination"
      });
    }
  }
}
document.addEventListener("DOMContentLoaded", function() {
  const collectionGrids = document.querySelectorAll('[id^="CollectionGrid-"]');
  collectionGrids.forEach((grid) => {
    const sectionId = grid.id.replace("CollectionGrid-", "");
    new CollectionPagination(sectionId);
  });
});
document.addEventListener("criticalReady", () => {
  const isCollectionPage = document.body.dataset.template === "collection";
  const isSearchPage = document.body.dataset.template === "search";
  window.useAjaxFiltering = isCollectionPage || isSearchPage;
  initSortDropdown();
  if (!window.useAjaxFiltering) {
    initFilterDrawer();
  } else {
    initFilterDrawer();
  }
});
